import React, { useState, useEffect } from "react";
import { CardBody, Card, Row, Col,  Form,
  FormGroup,Label,
  Input, Table, Button,Pagination, PaginationItem, PaginationLink
   } from 'reactstrap';
// import { ApiClient } from "services";
import { PayrollClient } from "services";
import {Trans} from "react-i18next";
import { NotificationManager } from "react-notifications";
import validator from "validator";
import BackButton from "components/refactoring/BackButton";
import Select from 'react-select'



// const ChartAccountOptions = [
//   { value: 'sales', label: 'Sales' },
//   { value: 'other_revenue', label: 'Other Revenue' },
//   { value: 'interest_income', label: 'Interest Income' },
//   { value: 'cost_goods_sold', label: 'Cost of Goods Sold' },
//   { value: 'direct_wages', label: 'Direct Wages' }
// ]

// const options = [
//   { value: 'chocolate', label: 'Chocolate' },
//   { value: 'strawberry', label: 'Strawberry' },
//   { value: 'vanilla', label: 'Vanilla' },
// ];

const Edit = ({t, match, xero}) => {
// const Edit = (props) => {

  const payrollClient = PayrollClient();

  const attendanceReportId  = match.params.id;

  const [chartAccountOptions, setChartAccountOptions] = useState([]);

  const [selectedOption, setSelectedOption] = useState(null);
  
  const getEmployee = (id) => {

    return  payrollClient.get(`employees/${id}`)
  }

  // const fetchDataListItems = () =>{

  //   fetchPayrollEmployees().then(({ data }) => {
  //       fetchAttendanceReportList(data);
  //   })
  // }

  const [ attendanceForm, setAttendanceForm ] = useState({
    // employee_name: "",
    time_in: "",
    time_out: "",
    remaining_amount: "",
    chart_account: "",
    //fixed: "",
    //date_to: ""
  })

  const [ employeeName, setEmployeeName ] = useState("")

  const saveItem = () => {

    console.log(attendanceForm)
    // console.log(selectedOption)
   
    // // // alert(JSON.stringify(attendanceForm, null, 2));

    payrollClient
    .put(`attendance_report/${attendanceReportId}`, {
      ...attendanceForm
    })
    .then(({ data }) => {
      console.log("Inside put")
      console.log(data)
      NotificationManager.success(t("Saved successfully"));

    })
    .catch((err) => {
      NotificationManager.error(t('Error while saving shift'));
    });
  }

  async function fetchChartAccountFromXero() {

    const response_accounts = await xero.get("accounts").get("data");
    const accounts = response_accounts.map((x) => ({
      label: x.Name,
      value: x.AccountID,
    }));

    setChartAccountOptions(accounts);
  };

  function handleSelectChartAccount(e){
    setAttendanceForm({...attendanceForm, chart_account: e.target.value})
    setSelectedOption(e.target.value)
  }


  

  useEffect(() => {
    payrollClient
    .get(`attendance_report/${attendanceReportId}`)
    .then(({ data }) => {

      setSelectedOption(data.chart_account)
      setAttendanceForm(data)

      console.log(data.employee)
      getEmployee(data.employee).then((res) => {

        //console.log(res)
        setEmployeeName(res.data.full_name)
      });

    })
    .catch((err) => {
      NotificationManager.error(t('Error while getting Data'));
    });

    fetchChartAccountFromXero();

  }, [])
  return (
    <div className="settingsmanagement">
      <Row>
        <Col xs="12" md="12" sm="12">
          <Card>
            <CardBody>
              <BackButton/>
              <h4 className="mt-2 mb-4"><Trans>Update Attendance Report</Trans></h4>

              {/* <Form className="form mt-3"> */}
                <Row>
                  <Col className="col-md pr-0">
                    <FormGroup>
                      <Label htmlFor="shiftname"><Trans>Employee</Trans></Label>

                      <Input
                        type="text"
                        disabled={true}
                        placeholder="Employee Name"
                        value={employeeName}
                      />
                    </FormGroup>
                  </Col>

                  <Col className="col-md pr-0">
                    <FormGroup>
                      <Label htmlFor="type"><Trans>Time In</Trans></Label>
                      <Input
                        type="text"
                        name="addTimefrom"
                        id="addTimefrom"
                        placeholder="8:00"
                        disabled={true}
                        value={attendanceForm.time_in}
                        onChange={(e) => setAttendanceForm({...attendanceForm, time_in: e.target.value})}
                      />
                    </FormGroup>
                  </Col>

                  <Col className="col-md">
                    <FormGroup>
                      <Label htmlFor="StartingDate"><Trans>Time Out</Trans></Label>

                      <Input
                        type="text"
                        name="addTimeto"
                        id="addTimeto"
                        placeholder="12:00"
                        disabled={true}
                        value={attendanceForm.time_out}
                        onChange={(e) => setAttendanceForm({...attendanceForm, time_out: e.target.value})}
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-md pr-0">
                    <FormGroup>
                      <Label htmlFor="shiftname"><Trans>Remaining Amount</Trans></Label>

                      <Input
                        type="text"
                        disabled={true}
                        placeholder="Remaining Amount"
                        value={attendanceForm.remaining_amount}
                        onChange={(e) => setAttendanceForm({...attendanceForm, remaining_amount: e.target.value})}
                      />
                    </FormGroup>
                  </Col>

                  <Col className="col-md pr-0">
                    <FormGroup>
                      <Label htmlFor="type"><Trans>Chart Account</Trans></Label>
                      {/* <Input
                        type="text"
                        // name="addTimefrom"
                        // id="addTimefrom"
                        // placeholder="8:00"
                        // disabled={true}
                        // value={attendanceForm.time_in}
                        // onChange={(e) => setAttendanceForm({...attendanceForm, time_in: e.target.value})}
                      /> */}
                       {/* <Select 
                       options={options}
                      //  defaultValue={selectedOption}
                      //  onChange={setSelectedOption}
                      //  onChange={(item) => setAttendanceForm({...attendanceForm, chart_account: item.value})}
                       /> */}

                       <select className="custom-select" value={selectedOption} onChange={handleSelectChartAccount}>
                       <option value="" >Select Option</option> 
                       {chartAccountOptions.map(item=>{
                        return(<option value={item.value}>{item.label}</option> )
                       })}
                       </select>

                    </FormGroup>
                  </Col>
                </Row>

                <Button
                  style={{ marginBottom: "10px" }}
                  color="success"
                  className="bt float-right mt-4"
                  type="submit"
                  onClick={saveItem}
                >
                  <Trans>Save</Trans>
                </Button>
              {/* </Form> */}

              <hr />

            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
};

export default Edit;


